/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DpaRouteImport } from './routes/dpa'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTaxFormsRouteImport } from './routes/dashboard/tax-forms'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardPendingPaymentsRouteImport } from './routes/dashboard/pending-payments'
import { Route as DashboardPayrollDefaultsRouteImport } from './routes/dashboard/payroll-defaults'
import { Route as DashboardNotificationsRouteImport } from './routes/dashboard/notifications'
import { Route as DashboardNotificationPreferencesRouteImport } from './routes/dashboard/notification-preferences'
import { Route as DashboardIntegrationsRouteImport } from './routes/dashboard/integrations'
import { Route as DashboardEmployeesRouteImport } from './routes/dashboard/employees'
import { Route as DashboardEmployeeSettingsRouteImport } from './routes/dashboard/employee-settings'
import { Route as DashboardCsvImportRouteImport } from './routes/dashboard/csv-import'
import { Route as DashboardCsvExportRouteImport } from './routes/dashboard/csv-export'
import { Route as DashboardCompletedPaymentsRouteImport } from './routes/dashboard/completed-payments'
import { Route as DashboardCompanyProfileRouteImport } from './routes/dashboard/company-profile'
import { Route as DashboardBillingRouteImport } from './routes/dashboard/billing'
import { Route as DashboardAddExistingUserRouteImport } from './routes/dashboard/add-existing-user'
import { Route as DashboardAddEmployeeRouteImport } from './routes/dashboard/add-employee'
import { Route as DashboardHelpIndexRouteImport } from './routes/dashboard/help/index'
import { Route as DashboardBillingIndexRouteImport } from './routes/dashboard/billing/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as DashboardHelpSlugRouteImport } from './routes/dashboard/help/$slug'
import { Route as DashboardEmployeesUserIdRouteImport } from './routes/dashboard/employees/$userId'
import { Route as DashboardCompanyProfileSignatoryRouteImport } from './routes/dashboard/company-profile.signatory'
import { Route as DashboardCompanyProfileEditRouteImport } from './routes/dashboard/company-profile.edit'
import { Route as DashboardBillingInvoicesRouteImport } from './routes/dashboard/billing/invoices'
import { Route as DashboardBillingBankDetailsRouteImport } from './routes/dashboard/billing/bank-details'
import { Route as DashboardBillingAddOnsRouteImport } from './routes/dashboard/billing/add-ons'
import { Route as DashboardAdminUsersRouteImport } from './routes/dashboard/admin/users'
import { Route as DashboardAdminUserImportRouteImport } from './routes/dashboard/admin/user-import'
import { Route as DashboardAdminTaxFormsRouteImport } from './routes/dashboard/admin/tax-forms'
import { Route as DashboardAdminSupportEmailsRouteImport } from './routes/dashboard/admin/support-emails'
import { Route as DashboardAdminSubscriptionPlansRouteImport } from './routes/dashboard/admin/subscription-plans'
import { Route as DashboardAdminSsoRouteImport } from './routes/dashboard/admin/sso'
import { Route as DashboardAdminSettingsRouteImport } from './routes/dashboard/admin/settings'
import { Route as DashboardAdminSellerProfileRouteImport } from './routes/dashboard/admin/seller-profile'
import { Route as DashboardAdminRevenueRouteImport } from './routes/dashboard/admin/revenue'
import { Route as DashboardAdminRequestsRouteImport } from './routes/dashboard/admin/requests'
import { Route as DashboardAdminOrganizationsRouteImport } from './routes/dashboard/admin/organizations'
import { Route as DashboardAdminOrgVerificationRouteImport } from './routes/dashboard/admin/org-verification'
import { Route as DashboardAdminOrgSubscriptionsRouteImport } from './routes/dashboard/admin/org-subscriptions'
import { Route as DashboardAdminOrgAddOnsRouteImport } from './routes/dashboard/admin/org-add-ons'
import { Route as DashboardAdminLedgerRouteImport } from './routes/dashboard/admin/ledger'
import { Route as DashboardAdminIntegrationsRouteImport } from './routes/dashboard/admin/integrations'
import { Route as DashboardAdminFeatureFlagsRouteImport } from './routes/dashboard/admin/feature-flags'
import { Route as DashboardAdminDemoRequestsRouteImport } from './routes/dashboard/admin/demo-requests'
import { Route as DashboardAdminAuditRouteImport } from './routes/dashboard/admin/audit'
import { Route as DashboardAdminActivityFeedRouteImport } from './routes/dashboard/admin/activity-feed'
import { Route as DashboardAdminActionsRouteImport } from './routes/dashboard/admin/actions'
import { Route as DashboardBillingInvoicesInvoiceIdRouteImport } from './routes/dashboard/billing/invoices.$invoiceId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DpaRoute = DpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTaxFormsRoute = DashboardTaxFormsRouteImport.update({
  id: '/tax-forms',
  path: '/tax-forms',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPendingPaymentsRoute =
  DashboardPendingPaymentsRouteImport.update({
    id: '/pending-payments',
    path: '/pending-payments',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPayrollDefaultsRoute =
  DashboardPayrollDefaultsRouteImport.update({
    id: '/payroll-defaults',
    path: '/payroll-defaults',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardNotificationsRoute = DashboardNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardNotificationPreferencesRoute =
  DashboardNotificationPreferencesRouteImport.update({
    id: '/notification-preferences',
    path: '/notification-preferences',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardIntegrationsRoute = DashboardIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEmployeesRoute = DashboardEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEmployeeSettingsRoute =
  DashboardEmployeeSettingsRouteImport.update({
    id: '/employee-settings',
    path: '/employee-settings',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCsvImportRoute = DashboardCsvImportRouteImport.update({
  id: '/csv-import',
  path: '/csv-import',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCsvExportRoute = DashboardCsvExportRouteImport.update({
  id: '/csv-export',
  path: '/csv-export',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCompletedPaymentsRoute =
  DashboardCompletedPaymentsRouteImport.update({
    id: '/completed-payments',
    path: '/completed-payments',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCompanyProfileRoute = DashboardCompanyProfileRouteImport.update({
  id: '/company-profile',
  path: '/company-profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBillingRoute = DashboardBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAddExistingUserRoute =
  DashboardAddExistingUserRouteImport.update({
    id: '/add-existing-user',
    path: '/add-existing-user',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAddEmployeeRoute = DashboardAddEmployeeRouteImport.update({
  id: '/add-employee',
  path: '/add-employee',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHelpIndexRoute = DashboardHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBillingIndexRoute = DashboardBillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardBillingRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHelpSlugRoute = DashboardHelpSlugRouteImport.update({
  id: '/help/$slug',
  path: '/help/$slug',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEmployeesUserIdRoute =
  DashboardEmployeesUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => DashboardEmployeesRoute,
  } as any)
const DashboardCompanyProfileSignatoryRoute =
  DashboardCompanyProfileSignatoryRouteImport.update({
    id: '/signatory',
    path: '/signatory',
    getParentRoute: () => DashboardCompanyProfileRoute,
  } as any)
const DashboardCompanyProfileEditRoute =
  DashboardCompanyProfileEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardCompanyProfileRoute,
  } as any)
const DashboardBillingInvoicesRoute =
  DashboardBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => DashboardBillingRoute,
  } as any)
const DashboardBillingBankDetailsRoute =
  DashboardBillingBankDetailsRouteImport.update({
    id: '/bank-details',
    path: '/bank-details',
    getParentRoute: () => DashboardBillingRoute,
  } as any)
const DashboardBillingAddOnsRoute = DashboardBillingAddOnsRouteImport.update({
  id: '/add-ons',
  path: '/add-ons',
  getParentRoute: () => DashboardBillingRoute,
} as any)
const DashboardAdminUsersRoute = DashboardAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminUserImportRoute =
  DashboardAdminUserImportRouteImport.update({
    id: '/admin/user-import',
    path: '/admin/user-import',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminTaxFormsRoute = DashboardAdminTaxFormsRouteImport.update({
  id: '/admin/tax-forms',
  path: '/admin/tax-forms',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminSupportEmailsRoute =
  DashboardAdminSupportEmailsRouteImport.update({
    id: '/admin/support-emails',
    path: '/admin/support-emails',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSubscriptionPlansRoute =
  DashboardAdminSubscriptionPlansRouteImport.update({
    id: '/admin/subscription-plans',
    path: '/admin/subscription-plans',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSsoRoute = DashboardAdminSsoRouteImport.update({
  id: '/admin/sso',
  path: '/admin/sso',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminSettingsRoute = DashboardAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminSellerProfileRoute =
  DashboardAdminSellerProfileRouteImport.update({
    id: '/admin/seller-profile',
    path: '/admin/seller-profile',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminRevenueRoute = DashboardAdminRevenueRouteImport.update({
  id: '/admin/revenue',
  path: '/admin/revenue',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminRequestsRoute = DashboardAdminRequestsRouteImport.update({
  id: '/admin/requests',
  path: '/admin/requests',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminOrganizationsRoute =
  DashboardAdminOrganizationsRouteImport.update({
    id: '/admin/organizations',
    path: '/admin/organizations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminOrgVerificationRoute =
  DashboardAdminOrgVerificationRouteImport.update({
    id: '/admin/org-verification',
    path: '/admin/org-verification',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminOrgSubscriptionsRoute =
  DashboardAdminOrgSubscriptionsRouteImport.update({
    id: '/admin/org-subscriptions',
    path: '/admin/org-subscriptions',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminOrgAddOnsRoute = DashboardAdminOrgAddOnsRouteImport.update({
  id: '/admin/org-add-ons',
  path: '/admin/org-add-ons',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminLedgerRoute = DashboardAdminLedgerRouteImport.update({
  id: '/admin/ledger',
  path: '/admin/ledger',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminIntegrationsRoute =
  DashboardAdminIntegrationsRouteImport.update({
    id: '/admin/integrations',
    path: '/admin/integrations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminFeatureFlagsRoute =
  DashboardAdminFeatureFlagsRouteImport.update({
    id: '/admin/feature-flags',
    path: '/admin/feature-flags',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminDemoRequestsRoute =
  DashboardAdminDemoRequestsRouteImport.update({
    id: '/admin/demo-requests',
    path: '/admin/demo-requests',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminAuditRoute = DashboardAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminActivityFeedRoute =
  DashboardAdminActivityFeedRouteImport.update({
    id: '/admin/activity-feed',
    path: '/admin/activity-feed',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminActionsRoute = DashboardAdminActionsRouteImport.update({
  id: '/admin/actions',
  path: '/admin/actions',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBillingInvoicesInvoiceIdRoute =
  DashboardBillingInvoicesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => DashboardBillingInvoicesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dpa': typeof DpaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard/add-employee': typeof DashboardAddEmployeeRoute
  '/dashboard/add-existing-user': typeof DashboardAddExistingUserRoute
  '/dashboard/billing': typeof DashboardBillingRouteWithChildren
  '/dashboard/company-profile': typeof DashboardCompanyProfileRouteWithChildren
  '/dashboard/completed-payments': typeof DashboardCompletedPaymentsRoute
  '/dashboard/csv-export': typeof DashboardCsvExportRoute
  '/dashboard/csv-import': typeof DashboardCsvImportRoute
  '/dashboard/employee-settings': typeof DashboardEmployeeSettingsRoute
  '/dashboard/employees': typeof DashboardEmployeesRouteWithChildren
  '/dashboard/integrations': typeof DashboardIntegrationsRoute
  '/dashboard/notification-preferences': typeof DashboardNotificationPreferencesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/payroll-defaults': typeof DashboardPayrollDefaultsRoute
  '/dashboard/pending-payments': typeof DashboardPendingPaymentsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/tax-forms': typeof DashboardTaxFormsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/actions': typeof DashboardAdminActionsRoute
  '/dashboard/admin/activity-feed': typeof DashboardAdminActivityFeedRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/demo-requests': typeof DashboardAdminDemoRequestsRoute
  '/dashboard/admin/feature-flags': typeof DashboardAdminFeatureFlagsRoute
  '/dashboard/admin/integrations': typeof DashboardAdminIntegrationsRoute
  '/dashboard/admin/ledger': typeof DashboardAdminLedgerRoute
  '/dashboard/admin/org-add-ons': typeof DashboardAdminOrgAddOnsRoute
  '/dashboard/admin/org-subscriptions': typeof DashboardAdminOrgSubscriptionsRoute
  '/dashboard/admin/org-verification': typeof DashboardAdminOrgVerificationRoute
  '/dashboard/admin/organizations': typeof DashboardAdminOrganizationsRoute
  '/dashboard/admin/requests': typeof DashboardAdminRequestsRoute
  '/dashboard/admin/revenue': typeof DashboardAdminRevenueRoute
  '/dashboard/admin/seller-profile': typeof DashboardAdminSellerProfileRoute
  '/dashboard/admin/settings': typeof DashboardAdminSettingsRoute
  '/dashboard/admin/sso': typeof DashboardAdminSsoRoute
  '/dashboard/admin/subscription-plans': typeof DashboardAdminSubscriptionPlansRoute
  '/dashboard/admin/support-emails': typeof DashboardAdminSupportEmailsRoute
  '/dashboard/admin/tax-forms': typeof DashboardAdminTaxFormsRoute
  '/dashboard/admin/user-import': typeof DashboardAdminUserImportRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/billing/add-ons': typeof DashboardBillingAddOnsRoute
  '/dashboard/billing/bank-details': typeof DashboardBillingBankDetailsRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRouteWithChildren
  '/dashboard/company-profile/edit': typeof DashboardCompanyProfileEditRoute
  '/dashboard/company-profile/signatory': typeof DashboardCompanyProfileSignatoryRoute
  '/dashboard/employees/$userId': typeof DashboardEmployeesUserIdRoute
  '/dashboard/help/$slug': typeof DashboardHelpSlugRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/billing/': typeof DashboardBillingIndexRoute
  '/dashboard/help/': typeof DashboardHelpIndexRoute
  '/dashboard/billing/invoices/$invoiceId': typeof DashboardBillingInvoicesInvoiceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/dpa': typeof DpaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard/add-employee': typeof DashboardAddEmployeeRoute
  '/dashboard/add-existing-user': typeof DashboardAddExistingUserRoute
  '/dashboard/company-profile': typeof DashboardCompanyProfileRouteWithChildren
  '/dashboard/completed-payments': typeof DashboardCompletedPaymentsRoute
  '/dashboard/csv-export': typeof DashboardCsvExportRoute
  '/dashboard/csv-import': typeof DashboardCsvImportRoute
  '/dashboard/employee-settings': typeof DashboardEmployeeSettingsRoute
  '/dashboard/employees': typeof DashboardEmployeesRouteWithChildren
  '/dashboard/integrations': typeof DashboardIntegrationsRoute
  '/dashboard/notification-preferences': typeof DashboardNotificationPreferencesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/payroll-defaults': typeof DashboardPayrollDefaultsRoute
  '/dashboard/pending-payments': typeof DashboardPendingPaymentsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/tax-forms': typeof DashboardTaxFormsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/admin/actions': typeof DashboardAdminActionsRoute
  '/dashboard/admin/activity-feed': typeof DashboardAdminActivityFeedRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/demo-requests': typeof DashboardAdminDemoRequestsRoute
  '/dashboard/admin/feature-flags': typeof DashboardAdminFeatureFlagsRoute
  '/dashboard/admin/integrations': typeof DashboardAdminIntegrationsRoute
  '/dashboard/admin/ledger': typeof DashboardAdminLedgerRoute
  '/dashboard/admin/org-add-ons': typeof DashboardAdminOrgAddOnsRoute
  '/dashboard/admin/org-subscriptions': typeof DashboardAdminOrgSubscriptionsRoute
  '/dashboard/admin/org-verification': typeof DashboardAdminOrgVerificationRoute
  '/dashboard/admin/organizations': typeof DashboardAdminOrganizationsRoute
  '/dashboard/admin/requests': typeof DashboardAdminRequestsRoute
  '/dashboard/admin/revenue': typeof DashboardAdminRevenueRoute
  '/dashboard/admin/seller-profile': typeof DashboardAdminSellerProfileRoute
  '/dashboard/admin/settings': typeof DashboardAdminSettingsRoute
  '/dashboard/admin/sso': typeof DashboardAdminSsoRoute
  '/dashboard/admin/subscription-plans': typeof DashboardAdminSubscriptionPlansRoute
  '/dashboard/admin/support-emails': typeof DashboardAdminSupportEmailsRoute
  '/dashboard/admin/tax-forms': typeof DashboardAdminTaxFormsRoute
  '/dashboard/admin/user-import': typeof DashboardAdminUserImportRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/billing/add-ons': typeof DashboardBillingAddOnsRoute
  '/dashboard/billing/bank-details': typeof DashboardBillingBankDetailsRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRouteWithChildren
  '/dashboard/company-profile/edit': typeof DashboardCompanyProfileEditRoute
  '/dashboard/company-profile/signatory': typeof DashboardCompanyProfileSignatoryRoute
  '/dashboard/employees/$userId': typeof DashboardEmployeesUserIdRoute
  '/dashboard/help/$slug': typeof DashboardHelpSlugRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/billing': typeof DashboardBillingIndexRoute
  '/dashboard/help': typeof DashboardHelpIndexRoute
  '/dashboard/billing/invoices/$invoiceId': typeof DashboardBillingInvoicesInvoiceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/contact': typeof ContactRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dpa': typeof DpaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard/add-employee': typeof DashboardAddEmployeeRoute
  '/dashboard/add-existing-user': typeof DashboardAddExistingUserRoute
  '/dashboard/billing': typeof DashboardBillingRouteWithChildren
  '/dashboard/company-profile': typeof DashboardCompanyProfileRouteWithChildren
  '/dashboard/completed-payments': typeof DashboardCompletedPaymentsRoute
  '/dashboard/csv-export': typeof DashboardCsvExportRoute
  '/dashboard/csv-import': typeof DashboardCsvImportRoute
  '/dashboard/employee-settings': typeof DashboardEmployeeSettingsRoute
  '/dashboard/employees': typeof DashboardEmployeesRouteWithChildren
  '/dashboard/integrations': typeof DashboardIntegrationsRoute
  '/dashboard/notification-preferences': typeof DashboardNotificationPreferencesRoute
  '/dashboard/notifications': typeof DashboardNotificationsRoute
  '/dashboard/payroll-defaults': typeof DashboardPayrollDefaultsRoute
  '/dashboard/pending-payments': typeof DashboardPendingPaymentsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/tax-forms': typeof DashboardTaxFormsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/actions': typeof DashboardAdminActionsRoute
  '/dashboard/admin/activity-feed': typeof DashboardAdminActivityFeedRoute
  '/dashboard/admin/audit': typeof DashboardAdminAuditRoute
  '/dashboard/admin/demo-requests': typeof DashboardAdminDemoRequestsRoute
  '/dashboard/admin/feature-flags': typeof DashboardAdminFeatureFlagsRoute
  '/dashboard/admin/integrations': typeof DashboardAdminIntegrationsRoute
  '/dashboard/admin/ledger': typeof DashboardAdminLedgerRoute
  '/dashboard/admin/org-add-ons': typeof DashboardAdminOrgAddOnsRoute
  '/dashboard/admin/org-subscriptions': typeof DashboardAdminOrgSubscriptionsRoute
  '/dashboard/admin/org-verification': typeof DashboardAdminOrgVerificationRoute
  '/dashboard/admin/organizations': typeof DashboardAdminOrganizationsRoute
  '/dashboard/admin/requests': typeof DashboardAdminRequestsRoute
  '/dashboard/admin/revenue': typeof DashboardAdminRevenueRoute
  '/dashboard/admin/seller-profile': typeof DashboardAdminSellerProfileRoute
  '/dashboard/admin/settings': typeof DashboardAdminSettingsRoute
  '/dashboard/admin/sso': typeof DashboardAdminSsoRoute
  '/dashboard/admin/subscription-plans': typeof DashboardAdminSubscriptionPlansRoute
  '/dashboard/admin/support-emails': typeof DashboardAdminSupportEmailsRoute
  '/dashboard/admin/tax-forms': typeof DashboardAdminTaxFormsRoute
  '/dashboard/admin/user-import': typeof DashboardAdminUserImportRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/dashboard/billing/add-ons': typeof DashboardBillingAddOnsRoute
  '/dashboard/billing/bank-details': typeof DashboardBillingBankDetailsRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRouteWithChildren
  '/dashboard/company-profile/edit': typeof DashboardCompanyProfileEditRoute
  '/dashboard/company-profile/signatory': typeof DashboardCompanyProfileSignatoryRoute
  '/dashboard/employees/$userId': typeof DashboardEmployeesUserIdRoute
  '/dashboard/help/$slug': typeof DashboardHelpSlugRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/billing/': typeof DashboardBillingIndexRoute
  '/dashboard/help/': typeof DashboardHelpIndexRoute
  '/dashboard/billing/invoices/$invoiceId': typeof DashboardBillingInvoicesInvoiceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact'
    | '/cookie-policy'
    | '/dashboard'
    | '/dpa'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/terms'
    | '/verify-email'
    | '/dashboard/add-employee'
    | '/dashboard/add-existing-user'
    | '/dashboard/billing'
    | '/dashboard/company-profile'
    | '/dashboard/completed-payments'
    | '/dashboard/csv-export'
    | '/dashboard/csv-import'
    | '/dashboard/employee-settings'
    | '/dashboard/employees'
    | '/dashboard/integrations'
    | '/dashboard/notification-preferences'
    | '/dashboard/notifications'
    | '/dashboard/payroll-defaults'
    | '/dashboard/pending-payments'
    | '/dashboard/profile'
    | '/dashboard/tax-forms'
    | '/dashboard/'
    | '/dashboard/admin/actions'
    | '/dashboard/admin/activity-feed'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/demo-requests'
    | '/dashboard/admin/feature-flags'
    | '/dashboard/admin/integrations'
    | '/dashboard/admin/ledger'
    | '/dashboard/admin/org-add-ons'
    | '/dashboard/admin/org-subscriptions'
    | '/dashboard/admin/org-verification'
    | '/dashboard/admin/organizations'
    | '/dashboard/admin/requests'
    | '/dashboard/admin/revenue'
    | '/dashboard/admin/seller-profile'
    | '/dashboard/admin/settings'
    | '/dashboard/admin/sso'
    | '/dashboard/admin/subscription-plans'
    | '/dashboard/admin/support-emails'
    | '/dashboard/admin/tax-forms'
    | '/dashboard/admin/user-import'
    | '/dashboard/admin/users'
    | '/dashboard/billing/add-ons'
    | '/dashboard/billing/bank-details'
    | '/dashboard/billing/invoices'
    | '/dashboard/company-profile/edit'
    | '/dashboard/company-profile/signatory'
    | '/dashboard/employees/$userId'
    | '/dashboard/help/$slug'
    | '/dashboard/admin/'
    | '/dashboard/billing/'
    | '/dashboard/help/'
    | '/dashboard/billing/invoices/$invoiceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact'
    | '/cookie-policy'
    | '/dpa'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/terms'
    | '/verify-email'
    | '/dashboard/add-employee'
    | '/dashboard/add-existing-user'
    | '/dashboard/company-profile'
    | '/dashboard/completed-payments'
    | '/dashboard/csv-export'
    | '/dashboard/csv-import'
    | '/dashboard/employee-settings'
    | '/dashboard/employees'
    | '/dashboard/integrations'
    | '/dashboard/notification-preferences'
    | '/dashboard/notifications'
    | '/dashboard/payroll-defaults'
    | '/dashboard/pending-payments'
    | '/dashboard/profile'
    | '/dashboard/tax-forms'
    | '/dashboard'
    | '/dashboard/admin/actions'
    | '/dashboard/admin/activity-feed'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/demo-requests'
    | '/dashboard/admin/feature-flags'
    | '/dashboard/admin/integrations'
    | '/dashboard/admin/ledger'
    | '/dashboard/admin/org-add-ons'
    | '/dashboard/admin/org-subscriptions'
    | '/dashboard/admin/org-verification'
    | '/dashboard/admin/organizations'
    | '/dashboard/admin/requests'
    | '/dashboard/admin/revenue'
    | '/dashboard/admin/seller-profile'
    | '/dashboard/admin/settings'
    | '/dashboard/admin/sso'
    | '/dashboard/admin/subscription-plans'
    | '/dashboard/admin/support-emails'
    | '/dashboard/admin/tax-forms'
    | '/dashboard/admin/user-import'
    | '/dashboard/admin/users'
    | '/dashboard/billing/add-ons'
    | '/dashboard/billing/bank-details'
    | '/dashboard/billing/invoices'
    | '/dashboard/company-profile/edit'
    | '/dashboard/company-profile/signatory'
    | '/dashboard/employees/$userId'
    | '/dashboard/help/$slug'
    | '/dashboard/admin'
    | '/dashboard/billing'
    | '/dashboard/help'
    | '/dashboard/billing/invoices/$invoiceId'
  id:
    | '__root__'
    | '/'
    | '/contact'
    | '/cookie-policy'
    | '/dashboard'
    | '/dpa'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/terms'
    | '/verify-email'
    | '/dashboard/add-employee'
    | '/dashboard/add-existing-user'
    | '/dashboard/billing'
    | '/dashboard/company-profile'
    | '/dashboard/completed-payments'
    | '/dashboard/csv-export'
    | '/dashboard/csv-import'
    | '/dashboard/employee-settings'
    | '/dashboard/employees'
    | '/dashboard/integrations'
    | '/dashboard/notification-preferences'
    | '/dashboard/notifications'
    | '/dashboard/payroll-defaults'
    | '/dashboard/pending-payments'
    | '/dashboard/profile'
    | '/dashboard/tax-forms'
    | '/dashboard/'
    | '/dashboard/admin/actions'
    | '/dashboard/admin/activity-feed'
    | '/dashboard/admin/audit'
    | '/dashboard/admin/demo-requests'
    | '/dashboard/admin/feature-flags'
    | '/dashboard/admin/integrations'
    | '/dashboard/admin/ledger'
    | '/dashboard/admin/org-add-ons'
    | '/dashboard/admin/org-subscriptions'
    | '/dashboard/admin/org-verification'
    | '/dashboard/admin/organizations'
    | '/dashboard/admin/requests'
    | '/dashboard/admin/revenue'
    | '/dashboard/admin/seller-profile'
    | '/dashboard/admin/settings'
    | '/dashboard/admin/sso'
    | '/dashboard/admin/subscription-plans'
    | '/dashboard/admin/support-emails'
    | '/dashboard/admin/tax-forms'
    | '/dashboard/admin/user-import'
    | '/dashboard/admin/users'
    | '/dashboard/billing/add-ons'
    | '/dashboard/billing/bank-details'
    | '/dashboard/billing/invoices'
    | '/dashboard/company-profile/edit'
    | '/dashboard/company-profile/signatory'
    | '/dashboard/employees/$userId'
    | '/dashboard/help/$slug'
    | '/dashboard/admin/'
    | '/dashboard/billing/'
    | '/dashboard/help/'
    | '/dashboard/billing/invoices/$invoiceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ContactRoute: typeof ContactRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  DpaRoute: typeof DpaRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dpa': {
      id: '/dpa'
      path: '/dpa'
      fullPath: '/dpa'
      preLoaderRoute: typeof DpaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/tax-forms': {
      id: '/dashboard/tax-forms'
      path: '/tax-forms'
      fullPath: '/dashboard/tax-forms'
      preLoaderRoute: typeof DashboardTaxFormsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/pending-payments': {
      id: '/dashboard/pending-payments'
      path: '/pending-payments'
      fullPath: '/dashboard/pending-payments'
      preLoaderRoute: typeof DashboardPendingPaymentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payroll-defaults': {
      id: '/dashboard/payroll-defaults'
      path: '/payroll-defaults'
      fullPath: '/dashboard/payroll-defaults'
      preLoaderRoute: typeof DashboardPayrollDefaultsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notifications': {
      id: '/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof DashboardNotificationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/notification-preferences': {
      id: '/dashboard/notification-preferences'
      path: '/notification-preferences'
      fullPath: '/dashboard/notification-preferences'
      preLoaderRoute: typeof DashboardNotificationPreferencesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/integrations': {
      id: '/dashboard/integrations'
      path: '/integrations'
      fullPath: '/dashboard/integrations'
      preLoaderRoute: typeof DashboardIntegrationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/employees': {
      id: '/dashboard/employees'
      path: '/employees'
      fullPath: '/dashboard/employees'
      preLoaderRoute: typeof DashboardEmployeesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/employee-settings': {
      id: '/dashboard/employee-settings'
      path: '/employee-settings'
      fullPath: '/dashboard/employee-settings'
      preLoaderRoute: typeof DashboardEmployeeSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/csv-import': {
      id: '/dashboard/csv-import'
      path: '/csv-import'
      fullPath: '/dashboard/csv-import'
      preLoaderRoute: typeof DashboardCsvImportRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/csv-export': {
      id: '/dashboard/csv-export'
      path: '/csv-export'
      fullPath: '/dashboard/csv-export'
      preLoaderRoute: typeof DashboardCsvExportRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/completed-payments': {
      id: '/dashboard/completed-payments'
      path: '/completed-payments'
      fullPath: '/dashboard/completed-payments'
      preLoaderRoute: typeof DashboardCompletedPaymentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/company-profile': {
      id: '/dashboard/company-profile'
      path: '/company-profile'
      fullPath: '/dashboard/company-profile'
      preLoaderRoute: typeof DashboardCompanyProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing': {
      id: '/dashboard/billing'
      path: '/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof DashboardBillingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/add-existing-user': {
      id: '/dashboard/add-existing-user'
      path: '/add-existing-user'
      fullPath: '/dashboard/add-existing-user'
      preLoaderRoute: typeof DashboardAddExistingUserRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/add-employee': {
      id: '/dashboard/add-employee'
      path: '/add-employee'
      fullPath: '/dashboard/add-employee'
      preLoaderRoute: typeof DashboardAddEmployeeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/help/': {
      id: '/dashboard/help/'
      path: '/help'
      fullPath: '/dashboard/help/'
      preLoaderRoute: typeof DashboardHelpIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/': {
      id: '/dashboard/billing/'
      path: '/'
      fullPath: '/dashboard/billing/'
      preLoaderRoute: typeof DashboardBillingIndexRouteImport
      parentRoute: typeof DashboardBillingRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/admin'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/help/$slug': {
      id: '/dashboard/help/$slug'
      path: '/help/$slug'
      fullPath: '/dashboard/help/$slug'
      preLoaderRoute: typeof DashboardHelpSlugRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/employees/$userId': {
      id: '/dashboard/employees/$userId'
      path: '/$userId'
      fullPath: '/dashboard/employees/$userId'
      preLoaderRoute: typeof DashboardEmployeesUserIdRouteImport
      parentRoute: typeof DashboardEmployeesRoute
    }
    '/dashboard/company-profile/signatory': {
      id: '/dashboard/company-profile/signatory'
      path: '/signatory'
      fullPath: '/dashboard/company-profile/signatory'
      preLoaderRoute: typeof DashboardCompanyProfileSignatoryRouteImport
      parentRoute: typeof DashboardCompanyProfileRoute
    }
    '/dashboard/company-profile/edit': {
      id: '/dashboard/company-profile/edit'
      path: '/edit'
      fullPath: '/dashboard/company-profile/edit'
      preLoaderRoute: typeof DashboardCompanyProfileEditRouteImport
      parentRoute: typeof DashboardCompanyProfileRoute
    }
    '/dashboard/billing/invoices': {
      id: '/dashboard/billing/invoices'
      path: '/invoices'
      fullPath: '/dashboard/billing/invoices'
      preLoaderRoute: typeof DashboardBillingInvoicesRouteImport
      parentRoute: typeof DashboardBillingRoute
    }
    '/dashboard/billing/bank-details': {
      id: '/dashboard/billing/bank-details'
      path: '/bank-details'
      fullPath: '/dashboard/billing/bank-details'
      preLoaderRoute: typeof DashboardBillingBankDetailsRouteImport
      parentRoute: typeof DashboardBillingRoute
    }
    '/dashboard/billing/add-ons': {
      id: '/dashboard/billing/add-ons'
      path: '/add-ons'
      fullPath: '/dashboard/billing/add-ons'
      preLoaderRoute: typeof DashboardBillingAddOnsRouteImport
      parentRoute: typeof DashboardBillingRoute
    }
    '/dashboard/admin/users': {
      id: '/dashboard/admin/users'
      path: '/admin/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/user-import': {
      id: '/dashboard/admin/user-import'
      path: '/admin/user-import'
      fullPath: '/dashboard/admin/user-import'
      preLoaderRoute: typeof DashboardAdminUserImportRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/tax-forms': {
      id: '/dashboard/admin/tax-forms'
      path: '/admin/tax-forms'
      fullPath: '/dashboard/admin/tax-forms'
      preLoaderRoute: typeof DashboardAdminTaxFormsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/support-emails': {
      id: '/dashboard/admin/support-emails'
      path: '/admin/support-emails'
      fullPath: '/dashboard/admin/support-emails'
      preLoaderRoute: typeof DashboardAdminSupportEmailsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/subscription-plans': {
      id: '/dashboard/admin/subscription-plans'
      path: '/admin/subscription-plans'
      fullPath: '/dashboard/admin/subscription-plans'
      preLoaderRoute: typeof DashboardAdminSubscriptionPlansRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/sso': {
      id: '/dashboard/admin/sso'
      path: '/admin/sso'
      fullPath: '/dashboard/admin/sso'
      preLoaderRoute: typeof DashboardAdminSsoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/settings': {
      id: '/dashboard/admin/settings'
      path: '/admin/settings'
      fullPath: '/dashboard/admin/settings'
      preLoaderRoute: typeof DashboardAdminSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/seller-profile': {
      id: '/dashboard/admin/seller-profile'
      path: '/admin/seller-profile'
      fullPath: '/dashboard/admin/seller-profile'
      preLoaderRoute: typeof DashboardAdminSellerProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/revenue': {
      id: '/dashboard/admin/revenue'
      path: '/admin/revenue'
      fullPath: '/dashboard/admin/revenue'
      preLoaderRoute: typeof DashboardAdminRevenueRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/requests': {
      id: '/dashboard/admin/requests'
      path: '/admin/requests'
      fullPath: '/dashboard/admin/requests'
      preLoaderRoute: typeof DashboardAdminRequestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/organizations': {
      id: '/dashboard/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/dashboard/admin/organizations'
      preLoaderRoute: typeof DashboardAdminOrganizationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/org-verification': {
      id: '/dashboard/admin/org-verification'
      path: '/admin/org-verification'
      fullPath: '/dashboard/admin/org-verification'
      preLoaderRoute: typeof DashboardAdminOrgVerificationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/org-subscriptions': {
      id: '/dashboard/admin/org-subscriptions'
      path: '/admin/org-subscriptions'
      fullPath: '/dashboard/admin/org-subscriptions'
      preLoaderRoute: typeof DashboardAdminOrgSubscriptionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/org-add-ons': {
      id: '/dashboard/admin/org-add-ons'
      path: '/admin/org-add-ons'
      fullPath: '/dashboard/admin/org-add-ons'
      preLoaderRoute: typeof DashboardAdminOrgAddOnsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/ledger': {
      id: '/dashboard/admin/ledger'
      path: '/admin/ledger'
      fullPath: '/dashboard/admin/ledger'
      preLoaderRoute: typeof DashboardAdminLedgerRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/integrations': {
      id: '/dashboard/admin/integrations'
      path: '/admin/integrations'
      fullPath: '/dashboard/admin/integrations'
      preLoaderRoute: typeof DashboardAdminIntegrationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/feature-flags': {
      id: '/dashboard/admin/feature-flags'
      path: '/admin/feature-flags'
      fullPath: '/dashboard/admin/feature-flags'
      preLoaderRoute: typeof DashboardAdminFeatureFlagsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/demo-requests': {
      id: '/dashboard/admin/demo-requests'
      path: '/admin/demo-requests'
      fullPath: '/dashboard/admin/demo-requests'
      preLoaderRoute: typeof DashboardAdminDemoRequestsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/audit': {
      id: '/dashboard/admin/audit'
      path: '/admin/audit'
      fullPath: '/dashboard/admin/audit'
      preLoaderRoute: typeof DashboardAdminAuditRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/activity-feed': {
      id: '/dashboard/admin/activity-feed'
      path: '/admin/activity-feed'
      fullPath: '/dashboard/admin/activity-feed'
      preLoaderRoute: typeof DashboardAdminActivityFeedRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/admin/actions': {
      id: '/dashboard/admin/actions'
      path: '/admin/actions'
      fullPath: '/dashboard/admin/actions'
      preLoaderRoute: typeof DashboardAdminActionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/billing/invoices/$invoiceId': {
      id: '/dashboard/billing/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/dashboard/billing/invoices/$invoiceId'
      preLoaderRoute: typeof DashboardBillingInvoicesInvoiceIdRouteImport
      parentRoute: typeof DashboardBillingInvoicesRoute
    }
  }
}

interface DashboardBillingInvoicesRouteChildren {
  DashboardBillingInvoicesInvoiceIdRoute: typeof DashboardBillingInvoicesInvoiceIdRoute
}

const DashboardBillingInvoicesRouteChildren: DashboardBillingInvoicesRouteChildren =
  {
    DashboardBillingInvoicesInvoiceIdRoute:
      DashboardBillingInvoicesInvoiceIdRoute,
  }

const DashboardBillingInvoicesRouteWithChildren =
  DashboardBillingInvoicesRoute._addFileChildren(
    DashboardBillingInvoicesRouteChildren,
  )

interface DashboardBillingRouteChildren {
  DashboardBillingAddOnsRoute: typeof DashboardBillingAddOnsRoute
  DashboardBillingBankDetailsRoute: typeof DashboardBillingBankDetailsRoute
  DashboardBillingInvoicesRoute: typeof DashboardBillingInvoicesRouteWithChildren
  DashboardBillingIndexRoute: typeof DashboardBillingIndexRoute
}

const DashboardBillingRouteChildren: DashboardBillingRouteChildren = {
  DashboardBillingAddOnsRoute: DashboardBillingAddOnsRoute,
  DashboardBillingBankDetailsRoute: DashboardBillingBankDetailsRoute,
  DashboardBillingInvoicesRoute: DashboardBillingInvoicesRouteWithChildren,
  DashboardBillingIndexRoute: DashboardBillingIndexRoute,
}

const DashboardBillingRouteWithChildren =
  DashboardBillingRoute._addFileChildren(DashboardBillingRouteChildren)

interface DashboardCompanyProfileRouteChildren {
  DashboardCompanyProfileEditRoute: typeof DashboardCompanyProfileEditRoute
  DashboardCompanyProfileSignatoryRoute: typeof DashboardCompanyProfileSignatoryRoute
}

const DashboardCompanyProfileRouteChildren: DashboardCompanyProfileRouteChildren =
  {
    DashboardCompanyProfileEditRoute: DashboardCompanyProfileEditRoute,
    DashboardCompanyProfileSignatoryRoute:
      DashboardCompanyProfileSignatoryRoute,
  }

const DashboardCompanyProfileRouteWithChildren =
  DashboardCompanyProfileRoute._addFileChildren(
    DashboardCompanyProfileRouteChildren,
  )

interface DashboardEmployeesRouteChildren {
  DashboardEmployeesUserIdRoute: typeof DashboardEmployeesUserIdRoute
}

const DashboardEmployeesRouteChildren: DashboardEmployeesRouteChildren = {
  DashboardEmployeesUserIdRoute: DashboardEmployeesUserIdRoute,
}

const DashboardEmployeesRouteWithChildren =
  DashboardEmployeesRoute._addFileChildren(DashboardEmployeesRouteChildren)

interface DashboardRouteChildren {
  DashboardAddEmployeeRoute: typeof DashboardAddEmployeeRoute
  DashboardAddExistingUserRoute: typeof DashboardAddExistingUserRoute
  DashboardBillingRoute: typeof DashboardBillingRouteWithChildren
  DashboardCompanyProfileRoute: typeof DashboardCompanyProfileRouteWithChildren
  DashboardCompletedPaymentsRoute: typeof DashboardCompletedPaymentsRoute
  DashboardCsvExportRoute: typeof DashboardCsvExportRoute
  DashboardCsvImportRoute: typeof DashboardCsvImportRoute
  DashboardEmployeeSettingsRoute: typeof DashboardEmployeeSettingsRoute
  DashboardEmployeesRoute: typeof DashboardEmployeesRouteWithChildren
  DashboardIntegrationsRoute: typeof DashboardIntegrationsRoute
  DashboardNotificationPreferencesRoute: typeof DashboardNotificationPreferencesRoute
  DashboardNotificationsRoute: typeof DashboardNotificationsRoute
  DashboardPayrollDefaultsRoute: typeof DashboardPayrollDefaultsRoute
  DashboardPendingPaymentsRoute: typeof DashboardPendingPaymentsRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardTaxFormsRoute: typeof DashboardTaxFormsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAdminActionsRoute: typeof DashboardAdminActionsRoute
  DashboardAdminActivityFeedRoute: typeof DashboardAdminActivityFeedRoute
  DashboardAdminAuditRoute: typeof DashboardAdminAuditRoute
  DashboardAdminDemoRequestsRoute: typeof DashboardAdminDemoRequestsRoute
  DashboardAdminFeatureFlagsRoute: typeof DashboardAdminFeatureFlagsRoute
  DashboardAdminIntegrationsRoute: typeof DashboardAdminIntegrationsRoute
  DashboardAdminLedgerRoute: typeof DashboardAdminLedgerRoute
  DashboardAdminOrgAddOnsRoute: typeof DashboardAdminOrgAddOnsRoute
  DashboardAdminOrgSubscriptionsRoute: typeof DashboardAdminOrgSubscriptionsRoute
  DashboardAdminOrgVerificationRoute: typeof DashboardAdminOrgVerificationRoute
  DashboardAdminOrganizationsRoute: typeof DashboardAdminOrganizationsRoute
  DashboardAdminRequestsRoute: typeof DashboardAdminRequestsRoute
  DashboardAdminRevenueRoute: typeof DashboardAdminRevenueRoute
  DashboardAdminSellerProfileRoute: typeof DashboardAdminSellerProfileRoute
  DashboardAdminSettingsRoute: typeof DashboardAdminSettingsRoute
  DashboardAdminSsoRoute: typeof DashboardAdminSsoRoute
  DashboardAdminSubscriptionPlansRoute: typeof DashboardAdminSubscriptionPlansRoute
  DashboardAdminSupportEmailsRoute: typeof DashboardAdminSupportEmailsRoute
  DashboardAdminTaxFormsRoute: typeof DashboardAdminTaxFormsRoute
  DashboardAdminUserImportRoute: typeof DashboardAdminUserImportRoute
  DashboardAdminUsersRoute: typeof DashboardAdminUsersRoute
  DashboardHelpSlugRoute: typeof DashboardHelpSlugRoute
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardHelpIndexRoute: typeof DashboardHelpIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAddEmployeeRoute: DashboardAddEmployeeRoute,
  DashboardAddExistingUserRoute: DashboardAddExistingUserRoute,
  DashboardBillingRoute: DashboardBillingRouteWithChildren,
  DashboardCompanyProfileRoute: DashboardCompanyProfileRouteWithChildren,
  DashboardCompletedPaymentsRoute: DashboardCompletedPaymentsRoute,
  DashboardCsvExportRoute: DashboardCsvExportRoute,
  DashboardCsvImportRoute: DashboardCsvImportRoute,
  DashboardEmployeeSettingsRoute: DashboardEmployeeSettingsRoute,
  DashboardEmployeesRoute: DashboardEmployeesRouteWithChildren,
  DashboardIntegrationsRoute: DashboardIntegrationsRoute,
  DashboardNotificationPreferencesRoute: DashboardNotificationPreferencesRoute,
  DashboardNotificationsRoute: DashboardNotificationsRoute,
  DashboardPayrollDefaultsRoute: DashboardPayrollDefaultsRoute,
  DashboardPendingPaymentsRoute: DashboardPendingPaymentsRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardTaxFormsRoute: DashboardTaxFormsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAdminActionsRoute: DashboardAdminActionsRoute,
  DashboardAdminActivityFeedRoute: DashboardAdminActivityFeedRoute,
  DashboardAdminAuditRoute: DashboardAdminAuditRoute,
  DashboardAdminDemoRequestsRoute: DashboardAdminDemoRequestsRoute,
  DashboardAdminFeatureFlagsRoute: DashboardAdminFeatureFlagsRoute,
  DashboardAdminIntegrationsRoute: DashboardAdminIntegrationsRoute,
  DashboardAdminLedgerRoute: DashboardAdminLedgerRoute,
  DashboardAdminOrgAddOnsRoute: DashboardAdminOrgAddOnsRoute,
  DashboardAdminOrgSubscriptionsRoute: DashboardAdminOrgSubscriptionsRoute,
  DashboardAdminOrgVerificationRoute: DashboardAdminOrgVerificationRoute,
  DashboardAdminOrganizationsRoute: DashboardAdminOrganizationsRoute,
  DashboardAdminRequestsRoute: DashboardAdminRequestsRoute,
  DashboardAdminRevenueRoute: DashboardAdminRevenueRoute,
  DashboardAdminSellerProfileRoute: DashboardAdminSellerProfileRoute,
  DashboardAdminSettingsRoute: DashboardAdminSettingsRoute,
  DashboardAdminSsoRoute: DashboardAdminSsoRoute,
  DashboardAdminSubscriptionPlansRoute: DashboardAdminSubscriptionPlansRoute,
  DashboardAdminSupportEmailsRoute: DashboardAdminSupportEmailsRoute,
  DashboardAdminTaxFormsRoute: DashboardAdminTaxFormsRoute,
  DashboardAdminUserImportRoute: DashboardAdminUserImportRoute,
  DashboardAdminUsersRoute: DashboardAdminUsersRoute,
  DashboardHelpSlugRoute: DashboardHelpSlugRoute,
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardHelpIndexRoute: DashboardHelpIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ContactRoute: ContactRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  DashboardRoute: DashboardRouteWithChildren,
  DpaRoute: DpaRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
